module.exports = __webpack_public_path__ + "img/navigationalAidsLightBeacon.44e5c75f.svg";